import React, { FunctionComponent, useEffect, useMemo } from 'react';
import { useStore } from 'effector-react';
import SpamStatusesList from '@components/SpamStatusesList';
import SpamStatusFilter from '@components/SpamStatusFilters';
import SpamPageLayout from '@components/SpamPageLayout';
import spamStatuses, { reset as resetSpamStatuses } from '@stores/spamStatuses';
import localeWeightStore, { LOCALE, resetLocaleWeight } from '@stores/localeWeight';

interface StatusesSpamRouteProps {}

const StatusesSpamRoute: FunctionComponent<StatusesSpamRouteProps> = () => {
  const { filters } = useStore(spamStatuses);
  const locale = useStore(localeWeightStore);

  useEffect(() => {
    return () => {
      resetSpamStatuses();
      resetLocaleWeight();
    };
  }, []);

  const hasActiveFilters = useMemo(() => {
    return Boolean(filters.nickname || filters.statusAuthorId || locale !== LOCALE.ALL);
  }, [filters, locale]);

  return (
    <SpamPageLayout
      filters={<SpamStatusFilter />}
      hasActiveFilters={hasActiveFilters}
    >
      <SpamStatusesList />
    </SpamPageLayout>
  );
};

export default StatusesSpamRoute;
